<footer id="footer_feb85407">
  <!-- Global site tag (gtag.js) - Google Analytics -->
  <script
    async=""
    src="https://www.googletagmanager.com/gtag/js?id=331016361"
    id="script_43cf0799"
  ></script>
  <script id="script_06d8131b">
    window.dataLayer = window.dataLayer || [];

    function gtag ()
    {
        dataLayer.push ( arguments );
    }

    gtag ( 'js', new Date () );
    gtag ( 'config', ‘331016361’ );
  </script>

  <div class="fleet-finder-footer" id="div_fleet-finder-footer_8e8468ac">
    <div class="top-footer" id="div_top-footer_efa6c450">
      <div class="top-footer-wrapper" id="div_top-footer-wrapper_dccc6203">
        <div class="top-row" id="div_top-row_b862448d">
          <div class="title-section" id="div_title-section_759349e7">
            <a
              target="_blank"
              href="https://trinityrail.com"
              class="trinity-logo"
              aria-label="TRINITY RAIL"
              title="TRINITY RAIL"
              id="a_trinity-logo_a982a1ec"
            >
              <img
                width="900"
                height="35"
                src="/assets/img/rsi_footer.png"
                alt="TRINITY RAIL"
                aria-label="TRINITY RAIL"
                title="TRINITY RAIL"
                id="img_90bbaf1b"
              />
            </a>
          </div>
          <div class="social-section" id="div_social-section_4624bd14">
            <a
              aria-label="youtube"
              title="youtube"
              target="_blank"
              href="https://www.youtube.com/channel/UCHnwPD5QsbI03kCdk5iiWCw"
              id="a_281d80a4"
            >
              <i class="pi pi-youtube social-link" id="i_pi_1568f327"></i>
            </a>

            <a
              aria-label="facebook"
              title="facebook"
              target="_blank"
              href="https://www.facebook.com/TrinityRailOfficial/"
              id="a_b2b50779"
            >
              <i class="pi pi-facebook social-link" id="i_pi_0b8f09f1"></i>
            </a>

            <a
              aria-label="instagram"
              title="instagram"
              target="_blank"
              href="https://www.instagram.com/trinityrailofficial/"
              id="a_e3eaab81"
            >
              <i class="pi pi-instagram social-link" id="i_pi_299502c8"></i>
            </a>

            <a
              aria-label="TRM rail"
              title="TRM rail"
              target="_blank"
              href="https://twitter.com/trinity_rail"
              id="a_a961a0a8"
            >
              <i class="pi pi-twitter social-link" id="i_pi_2ce2d344"></i>
            </a>

            <a
              aria-label="linkedin"
              title="linkedin"
              target="_blank"
              href="https://www.linkedin.com/company/trinityrail/"
              id="a_c847cdc5"
            >
              <i class="pi pi-linkedin social-link last" id="i_pi_faf34d15"></i>
            </a>
          </div>
        </div>

        <div class="top-row" id="div_top-row_7d1e0db9">
          <div
            class="contact-information"
            id="div_contact-information_5c25636c"
          >
            <div class="footer-paragraph" id="div_footer-paragraph_eb4e4d02">
              <p
                aria-label="MAIN OFFICE"
                title="MAIN OFFICE"
                class="text-footer-para"
                id="p_text-footer-para_cafdaca0"
              >
                MAIN OFFICE
              </p>
              14221 N. Dallas Parkway, Ste. 1100<br />Dallas, Texas 75254
              <br />
              <br />
              Customer Delivery: 800-227-8844<br />General & HR Inquiries:
              800-631-4420
            </div>
            <div class="footer-paragraph" id="div_footer-paragraph_3bcc3fff">
              <p
                aria-label="QUICK LINKS"
                title="QUICK LINKS"
                class="text-footer-para"
                id="p_text-footer-para_5eba4806"
              >
                QUICK LINKS
              </p>
              <a
                aria-label="Contact Us"
                title="Contact Us"
                target="_blank"
                (click)="setMixpanelTrack()"
                href="https://www.trinityrail.com/contact/"
                id="a_78fa1d49"
                >Contact Us</a
              >
              <br />
              <br />
              <a
                aria-label="TrinityRail.com"
                title="TrinityRail.com"
                href="https://www.TrinityRail.com"
                target="_blank"
                id="a_77b94ec9"
                >TrinityRail.com</a
              >
              <br />
              <br />
              <!-- <a
                aria-label="FAQs"
                title="FAQs"
                class="faq-button"
                (click)="goToFaq()"
                id="a_77b94ec9faq"
                >FAQs</a
              >-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-footer" id="div_bottom-footer_8c5c35ce">
      <div
        class="bottom-footer-wrapper"
        id="div_bottom-footer-wrapper_1a68cea0"
      >
        <div class="trinity-copyright" id="div_trinity-copyright_3c2e8099">
          © 2025 TrinityRail
        </div>

        <div
          class="bottom-footer-wrapper-end"
          id="div_bottom-footer-wrapper-end_6653193f"
        >
          <div class="legal-information" id="div_legal-information_6049fd8b">
            <a
              aria-label="Privacy Policy"
              title="Privacy Policy"
              target="_blank"
              href="https://legal.trin.net/Home/Privacy"
              id="a_e7a0fbb9"
              >Privacy Policy</a
            >
            |
            <a
              aria-label="Legal Information"
              title="Legal Information"
              target="_blank"
              href="https://legal.trin.net/"
              id="a_3e0ecb75"
              >Legal Information</a
            >
            |
            <a
              aria-label="Privacy & Cookie Policy"
              title="Privacy & Cookie Policy"
              target="_blank"
              href="https://legal.trin.net/Home/Privacy"
              id="a_800f191c"
              >Privacy & Cookie Policy</a
            >
          </div>
        </div>
      </div>

      <div
        *ngIf="showCookies"
        (click)="showCookieDialog()"
        class="cookies-btn"
        id="div_cookies-btn_c9b2bc12"
      >
        <div id="div_842a6477">COOKIES</div>
      </div>
    </div>
  </div>
</footer>

<!--COOKIE DIALOG-->
<div
  *ngIf="showCookies"
  [class.slide-out-bottom]="exitCookies"
  class="cookie-text-dialog-container slide-in-bottom"
  id="div_cookie-text-dialog-container_f398ca2a"
>
  <div class="cookie-dialog-text" id="div_cookie-dialog-text_529d651e">
    <p id="p_6cee696c">
      We use cookies to give you the best browsing experience. By clicking the
      button below, you agree to receive and store cookies on our site. You can
      allow, block or delete cookies installed on your computer by configuring
      your browser options installed on your computer. For more information
      about the use of cookies, please see our Privacy Policy.

      <button
        (click)="closeCookieDialog(true)"
        class="cookie-dialog-button accept"
        title="Accept"
        aria-label="Accept"
        id="button_cookie-dialog-button_80286a97"
      >
        Accept
      </button>

      <button
        (click)="closeCookieDialog(false)"
        title="Reject"
        aria-label="Reject"
        class="cookie-dialog-button"
        id="button_cookie-dialog-button_82c0632b"
      >
        Reject
      </button>

      <a
        aria-label="Read More"
        title="Read More"
        target="_blank"
        href="https://legal.trin.net/Home/Privacy"
        class="cookie-link"
        id="a_cookie-link_db74f946"
        >Read More</a
      >
    </p>
  </div>
</div>
